// initialed state
export const initialState = () => ({
	members: [],
	userAccounts: [],
	activeAccountId: null,
	loadingMembers: false,
});

const state = initialState();

export default state;
